
/**
 * Converts an array of objects to CSV string
 */
export function objectsToCSV(data: Record<string, any>[]): string {
  if (data.length === 0) return '';
  
  // Extract headers from the first object
  const headers = Object.keys(data[0]);
  
  // Create CSV header row
  const headerRow = headers.join(',');
  
  // Create rows for each object
  const rows = data.map(obj => {
    return headers.map(header => {
      // Handle null/undefined values
      const value = obj[header] === null || obj[header] === undefined ? '' : obj[header];
      
      // If value contains commas, quotes, or newlines, wrap it in quotes
      const cell = String(value).replace(/"/g, '""'); // Escape quotes
      if (cell.includes(',') || cell.includes('"') || cell.includes('\n')) {
        return `"${cell}"`;
      }
      return cell;
    }).join(',');
  });
  
  // Combine header and rows
  return [headerRow, ...rows].join('\n');
}

/**
 * Downloads a string as a file
 */
export function downloadCSV(data: string, filename: string): void {
  const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.display = 'none';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
